<template>
  <ECard
    data-test-id="footer-card"
    class="footer-card"
  >
    <slot name="illustrations" />
    <div class="footer-card__body">
      <div class="footer-card__title">
        {{ title }}
      </div>
      <EButton
        as="a"
        target="blank"
        variant="outline"
        :href="buttonLink"
        rel="noopener"
        size="s"
        class="footer-card__more"
        data-test-id="footer-card-more"
        data-track-id="main-footer-card-cta"
      >
        {{ buttonText }}
      </EButton>
      <div
        v-if="sponsored"
        class="footer-card__more"
      >
        {{ $t(`common.footer.card.sponsored`) }}
      </div>
    </div>
  </ECard>
</template>

<script>
import EButton from '~~/common/vue/components/button';
import ECard from '~~/common/vue/components/card';

export default {
  name: 'EFooterCard',
  components: {
    EButton,
    ECard,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonLink: {
      type: String,
      required: true,
    },
    sponsored: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>

.footer-card {
  max-width: 328px;
  margin: 0 $space-s $space-s;
  background: var(--color-background-primary);
  display: flex;
  place-self: center;

  @include tablet {
    max-width: 360px;
  }
}

.footer-card__body {
  color: var(--color-text-secondary);
  font-weight: $font-weight-m;
  font-size: $font-s;
  margin: $space-m;
  margin-left: 0;
}

.footer-card__title {
  color: var(--color-text-primary);
  font-weight: $font-weight-1l;
  font-size: $font-l;
}

.footer-card__more {
  margin-top: $space-1s;
}
</style>
